module.exports = __webpack_public_path__ + "img/tpc-37.4dbb8fbb.webp";